import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "../common/commonDomain";
import {
  ChangeSignatureInArticlesOfAssociation,
  ChangeSignatureInArticlesOfAssociationForm,
} from "./changeSignatureInArticlesOfAssociationDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: ChangeSignatureInArticlesOfAssociation,
): ChangeSignatureInArticlesOfAssociationForm {
  return new ChangeSignatureInArticlesOfAssociationForm(dispatch, context, data);
}

export function applyForm(
  form: ChangeSignatureInArticlesOfAssociationForm,
): ChangeSignatureInArticlesOfAssociation {
  return {
    type: DecisionType.changeSignatureInArticlesOfAssociation,
    paragraph: form.paragraph.selected,
    texts: form.texts.map((m) => ({
      text: m.model.validatedValue,
      language: m.locale,
    })),
  };
}

export function handleEvent(form: ChangeSignatureInArticlesOfAssociationForm, event: DbotEvent) {
  form.handleEvent(event);
}

export function validate(form: ChangeSignatureInArticlesOfAssociationForm): boolean {
  return form.validate();
}

export function isValid(form: ChangeSignatureInArticlesOfAssociationForm): boolean {
  return form.isValid;
}

export const changeSignatureInArticlesOfAssociationHandler: DecisionTypeHandler<
  DecisionType.changeSignatureInArticlesOfAssociation,
  ChangeSignatureInArticlesOfAssociation,
  ChangeSignatureInArticlesOfAssociationForm
> = {
  type: DecisionType.changeSignatureInArticlesOfAssociation,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent,
};
